export const IHideErrorUseCaseType = Symbol('IHideErrorUseCase');
